// @ts-ignore
interface _Stat {
  value: number;
  label: string;
  prefix?: string;
  suffix?: string;
  // ...
}

export const createStatsCounter = () => {
  // On retire les valeurs statiques car elles sont déjà dans le HTML
  const statsElements = document.querySelectorAll('[data-section="stats"] h2');

  const animateValue = (
    element: HTMLElement,
    start: number,
    end: number,
    duration: number,
    prefix: string = "",
    suffix: string = ""
  ) => {
    let startTimestamp: number | null = null;

    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const current = Math.floor(progress * (end - start) + start);

      const formattedValue = current.toLocaleString('fr-FR');
      element.innerHTML = `${prefix}${formattedValue.replace(/\s/g, '&nbsp;')}${suffix}`;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  };

  const setupStatAnimation = (element: HTMLElement) => {
    // Extraire la valeur numérique et le format
    const originalText = element.textContent || '';
    const numericValue = parseInt(originalText.replace(/[^0-9]/g, ''));
    const hasEuro = originalText.includes('€');

    // Sauvegarder le format original
    element.setAttribute('data-original', originalText);

    // Configurer l'observateur d'intersection
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const prefix = originalText.startsWith('+') ? '+' : '';
            const suffix = hasEuro ? ' €' : '';
            animateValue(element, 0, numericValue, 2000, prefix, suffix);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(element);
  };

  // Initialiser les animations pour chaque élément stat
  statsElements.forEach((element) => setupStatAnimation(element as HTMLElement));

};
